import { useEffect, useRef, useParams, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Localize } from "../../../app/lang/langs";
import styles from "../Dashboard.module.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import NewsModal from "./NewsModal";
import addIcon from "../../../assets/images/add.png";
import addIconFocus from "../../../assets/images/addFocus.png";
import ImageButton from "../../buttons/ImageButton";
import { checkPermission } from "../../../app/utils/helpers";
import { config } from "../../../app/utils/config";
import AddNewsModal from "./AddNewsModal";
import deleteIcon from "../../../assets/images/delete.png";
import deleteIconFocus from "../../../assets/images/delete-orange.png";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteNews, setNewsList } from "../../../containers/dashboard/dashboardSlice";

export default function NewsTable() {

    const dispatch = useDispatch();
    const newsList = useSelector((state) => state.dashboard.news)
    const [selectedNews, setSelectedNews] = useState(null)
    const [visible, setVisible] = useState(false)

    const dateBodyTemplate = (rowData, column) => {
        return moment(rowData[column.field]).format("DD/MM/YYYY HH:mm")
    }
    const onNewsSelect = (e) => {
        setSelectedNews(e.data)
    }

    const rowClassName = (row) => {
        const isSeen = row.seen;
        return isSeen ? "" : styles.rowUnanswered;
    }

    const header = () => {
        return (<div className="d-flex justify-content-between align-items-center">
            <span className="p-input-icon-left">
                {Localize("NEWS")}
            </span>
            {checkPermission(config.scopes.news, config.permissionTypes.edit) &&
                <ImageButton
                    tooltip={Localize("ADD_NEWS")}
                    image={addIcon}
                    imageFocus={addIconFocus}
                    onClick={() => { setVisible(true) }}
                    active={true}
                    width={32}
                />}
        </div>);
    }

    const deleteNewsBody = (row) => {
        if (checkPermission(config.scopes.news, config.permissionTypes.edit))
            return (<ImageButton
                tooltip={Localize("DELETE_NEWS")}
                image={deleteIcon}
                imageFocus={deleteIconFocus}
                onClick={() => { confirmDeleteNotification(row.id) }}
                active={true}
                width={32}
            />)
    }

    const confirmDeleteNotification = (newsId) => {

        const accept = async (newsId) => {
            const response = await dispatch(deleteNews({ newsId: newsId })).unwrap();
            if (response && response.responseData && response.responseData.status) {
                dispatch(setNewsList(newsList.filter(n => n.id !== newsId)))
            }
        }

        const reject = () => { }
        confirmDialog({
            message: Localize("ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_NEWS"),
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept: () => accept(newsId),
            reject
        })
    }

    const messageTemplate = (rowData) => (
        <div style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={rowData.message}>
            {rowData.message}
        </div>
    )

    const titleTemplate = (rowData) => (
        <div style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} title={rowData.title}>
            {rowData.title}
        </div>
    )

    return (
        <div className={styles.vcompCard}>
            <DataTable rowClassName={rowClassName}
                value={newsList}
                tableStyle={{ minWidth: '50rem' }}
                paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                scrollable scrollHeight="260px"
                selection={selectedNews}
                header={header}
                className="p-datatable-sm"
                onRowClick={onNewsSelect} 
                selectionMode="single">
                <Column field="title" header={Localize("Title")} body={titleTemplate} style={{ minWidth: '8rem', maxWidth: '12rem' }}></Column>
                <Column field="message" header={Localize("Message")} body={messageTemplate} style={{ minWidth: '12rem', maxWidth: '16rem' }}></Column>
                <Column field="created_by" header={Localize("created_by")} style={{ minWidth: '7rem' }}></Column>
                <Column field="created_at" header={Localize("created_at")} style={{ minWidth: '7rem' }} dataType="date" body={dateBodyTemplate}></Column>
                <Column frozen body={deleteNewsBody} style={{ width: '4rem' }}></Column>
            </DataTable>
            <NewsModal selectedNews={selectedNews} onHide={() => setSelectedNews(null)} />
            <AddNewsModal visible={visible} setVisible={setVisible} />
        </div>
    );
}